/* RESPONSIBLE TEAM: team-ai-insights */
// Bridge route for QA received-reviews React view
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class AutomationFinAiAgentAnalyzeMonitorReviewsReceivedRoute extends Route {
  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.analyze.monitor.reviews.received',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(AutomationFinAiAgentAnalyzeMonitorReviewsReceivedRoute, {
  overrideRenderTemplate: false,
});
